<template>
<v-container>
    <v-row align="center"
      justify="center">
        <v-col>

  <v-card
  elevation="2"
   outlined
   width="500"
>

<v-img
      height="250"
      src="/keygenebuilding.png"
    ></v-img>

    <v-card-text>

    <v-form @submit.prevent="login" v-model="valid">

    <h1 class="text-center">
      log in
    </h1>
    <div class="text-center betanotice">
      {{ app_title }}
    </div>
      <v-text-field
      label="email address"
      v-model="email"
      append-icon="mdi-at"
      :rules="[rules.required, rules.email]"
      hide-details="auto"
    ></v-text-field>

    <v-text-field
      v-model="password"
      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
      :rules="[rules.required, rules.min]"
      :type="show1 ? 'text' : 'password'"
      name="input-10-1"
      label="password"
      hint="At least 4 characters"
      counter
      @click:append="show1 = !show1"
          ></v-text-field>

      <v-btn type="submit" color="primary" :disabled="!valid" >Login</v-btn>
    </v-form>

    </v-card-text>

        <v-card-text v-if="errorMsg">

       <v-alert 
      border="right"
      colored-border
      type="error"
      elevation="2"
    >
    error: <strong>{{errorMsg}}</strong>. Please log in again.
    </v-alert>

    </v-card-text>

</v-card>

        </v-col>


    </v-row>

</v-container>
</template>

<style>
.login {
  display: flex;
  flex-direction: column;
  width: 300px;
  padding: 10px;
}
.betanotice {
  font-weight: normal;
  font-size: 1em;
  font-style: italic;
  margin: auto;
  text-align: center;
}
</style>

<script>

export default {
  name: "login-user",
  data() {
    return {
      app_title: process.env.VUE_APP_TITLE,
      email: null,
      password: null,
      errorMsg: null,
      show1: false,
      valid: false,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 4 || 'Min 4 characters',
        max: v => v.length <= 10 || 'Max 10 characters',
        email: v => /^[a-z.-]+@[a-z.-]+\.[a-z]+$/i.test(v) || 'must be a valid email'
      },
    };
  },
  computed: {
    loggedIn() {
      return this.$store.getters['auth/isAuthenticated'];
    },
  },
  created() {
    if(this.$route.params.error) {
      this.errorMsg = this.$route.params.error;
    }
    if (this.loggedIn) {
      this.$router.push({name: "home"});
    }
  },
  methods: {
    login: function() {
      this.$store.dispatch('auth/retrieveToken', { 
        email: this.email,
        password: this.password
        })
        .then(response => {
          if(response.status == 200) {
            try {
              if(response.data.role == "admin") {
                console.log("admin logged in");
                this.$router.push({name: "admin"});
              }
              else {
                console.log('login succesful')
                this.$router.push({name: "home"});
              }
            }
            catch(error) {
              console.log("error with login response");
              this.$router.push({name: "home"});
            }
          }
      });
    }
  }
};
</script>